import axios from "axios";
import { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import { API_URL } from "../API/config";
import { message } from "antd";
import { eventManager } from "../EventEmitter";
import { Button } from "@mui/material";

interface Variant {
  variantName: string;
  storage: string;
  colorCode: string;
  colorName: string;
  ramSize: string;
  price: number;
  dealPrice: number;
  _id: string;
}

interface Address {
  addressType: string;
  gstNumber: string;
  businessName: string;
  alternateNumber: string;
  buildingAndBlockNumber: string;
  email: string;
  firstName: string;
  houseNumberAndFloor: string;
  landmark: string;
  lastName: string;
  locality: string;
  phoneNumber: string;
  pincode: string;
}

interface CartItem {
  variantId: any;
  variant: Variant;
  product: string;
  price: number;
  DeliveryType: string;
  productName: string;
  _id: string;
  categories: string;
}

interface WishlistItem {
  variant: Variant;
  product: string;
  price: number;
  _id: string;
}

interface User {
  _id: string;
  email: string;
  role: string;
  cart: CartItem[];
  wishlist: WishlistItem[];
  __v: number;
  termscondition: boolean;
  passwordChangedAt: string;
  firstName: string;
  lastName: string;
  position: string;
  shippingAddress: {
    addressType: string;
    gstNumber: string;
    businessName: string;
    alternateNumber: string;
    buildingAndBlockNumber: string;
    email: string;
    firstName: string;
    houseNumberAndFloor: string;
    landmark: string;
    lastName: string;
    locality: string;
    phoneNumber: string;
    pincode: string;
  };
  ExchangeType: string;
}

const PaymentSuccess = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const merchantOrderId = searchParams.get("merchantId");
  const Clienttoken = searchParams.get("Clienttoken");

  const [paymentDetails, setPaymentDetails] = useState<any>();

  const handlePaymentResponse = async () => {
    try {
        const token = sessionStorage.getItem("token"); 
                 if(!token){
                   message.error("Login required!") 
                   return
                 }
      const data = {
        merchantOrderId: merchantOrderId,
        Clienttoken: Clienttoken,
      };

      const res = await axios.post(`${API_URL}/payment/validate`, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setPaymentDetails(res.data);
      if (res.data.state === "COMPLETED") {
        handlePayment(
          res.data?.paymentDetails[0]?.transactionId,
          res.data?.paymentDetails[0]?.paymentMode
        );
      } else {
        message.error(res.data.state);
      }
    } catch (error: any) {
      console.log(error);
      message.error("Something went wrong!");
    }
  };

  const handlePayment = async (transactionID: any, paymentMode: any) => {
    const token = sessionStorage.getItem("token"); 
             if(!token){
               message.error("Login required!") 
               return
             }

    const orderData = JSON.parse(localStorage.getItem("orderData") || "{}");

    try {
      await axios.post(
        `${API_URL}/api/orders`,
        {
          ...orderData,
          paymentStatus: "paid",
          transactionId: transactionID,
          onlinePayment: paymentMode,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      message.success("Order Placed Successfully");
      localStorage.removeItem("orderData");
      await handleclearCart();
    } catch (error: any) {
      console.log(error.message);
    }
  };

  const [data, setData] = useState<User | null>(null);

  const getUser = async () => {
  const token = sessionStorage.getItem("token"); 
           if(!token){
             message.error("Login required!") 
             return
           }
    try {
      const res = await axios.get(`${API_URL}/api/user/getMe`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setData(res.data.user);
      handlePaymentResponse();
    } catch (error: any) {
      console.log(error);
      message.error(
        error.response?.data?.message || "Failed to fetch products."
      );
    }
  };

  const handleclearCart = async () => {
  const token = sessionStorage.getItem("token"); 
           if(!token){
             message.error("Login required!") 
             return
           }
    try {
      if (data?.cart && data.cart.length > 0) {
        await Promise.all(
          data.cart.map((val) =>
            axios.delete(`${API_URL}/api/user/cart/remove`, {
              headers: {
                Authorization: `Bearer ${token}`,
              },
              data: {
                productId: val.product,
                variantDetails: {
                  storage: val.variant.storage,
                  colorName: val.variant.colorName,
                  ramSize: val.variant.ramSize,
                },
              },
            })
          )
        );
      }
      eventManager.emit("cartUpdated");
    } catch (error: any) {
      message.error(error.response?.data?.message || "Failed to clear cart.");
    }
  };

  useEffect(() => {
    getUser();
  }, []);
  return (
    <>
      {paymentDetails?.state === "COMPLETED" ? (
        <section className="pb-4" style={{ paddingTop: "6rem" }}>
          <Container>
            <div>
              <div>
                <div className="model-success text-center">
                  <img className="img-fluid" src="/assets/Vnext bag.png" />
                  <h4>Thank you for your order</h4>
                  <p>
                    We are thrilled to confirm your order and to view your
                    complete order details, track or make any changes, simply
                    click the button below.
                  </p>
                  <h6 className="pb-3">
                    Transaction Id:
                    {paymentDetails?.paymentDetails[0]?.transactionId || "-"}
                  </h6>
                  <Link to={"/orders"} style={{ textDecoration: "none" }}>
                    <Button variant="contained">View Order</Button>
                  </Link>
                </div>
              </div>
            </div>
          </Container>
        </section>
      ) : (
        <section className="pb-4" style={{ paddingTop: "6rem" }}>
          <Container>
            <div>
              <div>
                <div className="model-success text-center">
                  <img className="img-fluid" src="/assets/Vnext bag.png" />
                  <h4 style={{ color: "red" }}>Transcation Failed!</h4>
                  <p>Try again later!</p>
                </div>
              </div>
            </div>
          </Container>
        </section>
      )}
    </>
  );
};

export default PaymentSuccess;
